module.exports = __webpack_public_path__ + "img/banner_tr.9923cbe8.jpg";